import Authorization from './Authorization';
import GiftWall from './GiftWall';
export default {
  name: 'Toolbar',
  data: function data() {
    return {
      giftwall: null,
      authorization: null
    };
  },
  props: {
    authentication: Object,
    giftList: Array,
    giftTabs: Array,
    isOpenGiftWall: Boolean
  },
  mounted: function mounted() {
    this.giftwall = this.$refs.giftwall;
    this.authorization = this.$refs.authorization;
  },
  methods: {
    rechargeHandler: function rechargeHandler() {
      this.$emit('recharge');
    },
    authenticateHandler: function authenticateHandler() {
      this.$emit('authenticate');
    },
    sendGiftHandler: function sendGiftHandler(id, count, finanType) {
      this.$emit('sendgift', id, count, finanType);
    },
    openGiftWallHandler: function openGiftWallHandler() {
      this.$emit('opengiftwall');
    }
  },
  components: {
    giftwall: GiftWall,
    authorization: Authorization
  }
};